import React from 'react';

import { FormProvider } from 'react-hook-form';

import { ISelectOption } from 'components/shared/BaseFormComponents/Select/types';

import cs from '../../../../index.module.css';
import { useAreaWizardContext } from '../../context';
import { AreaButtonsGroup } from './AreaButtonsGroup';
import { AreaForm } from './AreaForm';
import { useAreaForm } from './useAreaForm';

const Area = () => {
  const { tripEvent, nextStep, updateData, onSubmit } = useAreaWizardContext();

  const { methods, tripEventDeafultValuesController, ...rest } = useAreaForm();
  const { setValue } = methods;

  const handledOnCreateOption = async (inputValue: ISelectOption) => {
    const currentSelectValue = {
      id: inputValue.id?.toString() || '',
      name: inputValue.name,
      label: inputValue.name,
      value: inputValue.id,
    };
    setValue('attachedPage', currentSelectValue);
    updateData('default', { attachedPages: [currentSelectValue] });
    nextStep();
  };

  return (
    <FormProvider {...methods}>
      <div className={cs.form}>
        <AreaForm tripEvent={tripEvent} onCreateOption={handledOnCreateOption} {...rest} />

        <AreaButtonsGroup
          tripEvent={tripEvent}
          onSubmit={onSubmit}
          tripEventDeafultValuesController={tripEventDeafultValuesController}
        />
      </div>
    </FormProvider>
  );
};

export { Area };
